export default __webpack_public_path__ + "static/media/918.eb2d63b3.jpg";